<template lang="pug">
.bet-slip
  //- small {{ isCashoutAvailable }}
  template(v-if="filterMenu != 'transfer'")
    .bet-slip-wrapper(:class="{ live: isLiveMarket }")
      .stake-info-wrapper
        .bet-type          
          template(v-if="['sportsbook','adjustment','void'].includes(filterMenu)")
            .head-wrapper
              ThemeImage.icon(:src="'/images/light/sport/blue/' + getSportsImage(match) ")
              template(v-if="racingList.includes(match.sports_type)")
                | {{ sports[match.sports_type] }}
              template(v-else)
                | {{ sports[match.sports_type] }} - {{ betType(match) }}
                template(v-if="isTM(match) || match.is_tm") {{$t('ui.time_machine_tm')}}
            template(v-if="['void'].includes(filterMenu)")
              .bet-status(:class="match.bet_status.toLowerCase()")
                span {{ (match.bet_status_code == 1) ? $t('ui.reject') : $t('ui.void') }}            
          template(v-else-if="['livecasino'].includes(filterMenu)")
            .head-wrapper
              img.icon(src="/images/icon-other/casino-icon.svg?v=12")
              | {{ $t("ui.casino") }}
          template(v-else-if="['slots'].includes(filterMenu)")
            .head-wrapper
              img.icon(src="/images/icon-other/slot-icon.svg?v=12")
              | {{ $t("ui.slots") }}
          template(v-else-if="['esports2'].includes(filterMenu)")
            .head-wrapper
              img.icon(src="/images/icon-sport-svg/20.svg?v=12")
              | {{ $t("ui.esports2") }}
          template(v-else-if="['tournament','tournament_refund'].includes(filterMenu)")
            .head-wrapper
              img.icon(src="/images/icon-other/tournament.png?v=12")
              | {{ $t("ui.tournament") }}
            .bet-status(v-if="['tournament_refund'].includes(filterMenu)")
              span {{ $t("ui.refund") }}

          template(v-if="!status")
            .bet-status.won(v-if="parseFloat(match.winlose) > 0")
              span {{ $t("ui.win") }}
            .bet-status.draw(v-else-if="parseFloat(match.winlose) == 0")
              span {{ $t("ui.draw") }}
            .bet-status.lose(v-else-if="parseFloat(match.winlose) < 0")
              span {{ $t("ui.lose") }}
          template(v-else)
            .bet-status(:class="match.bet_status.toLowerCase()")
              span {{ $t("ui." + match.bet_status.toLowerCase()) }}
        .stake-info(v-if="['sportsbook','adjustment','void'].includes(filterMenu)")
          .betslip-match
            .team-involved
              template(v-if="racingList.includes(match.sports_type)")
                template(v-if="racingList2.includes(match.sports_type)")
                  template(v-if="['ML','1X2'].includes(match.bet_type)")
                    span {{ match.home_away == 1 ? getName(match, 1) : getName(match, 2) }}
                  template(v-if="['OU','OE'].includes(match.bet_type)")
                    span {{ match.home_away == 1 ? getName(match, 1) : getName(match, 2) }}
                  template(v-if="['CS'].includes(match.bet_type)")
                    span {{ ['5-0','4-1','3-2'].includes(match.criteria1) ? getName(match, 1) : getName(match, 2) }}
                template(v-else-if="racingList6.includes(match.sports_type) || racingList7.includes(match.sports_type)")
                  template(v-if="['ML'].includes(match.bet_type)")
                    span {{ match.home_away == 1 ? getName(match, 1) : getName(match, 2) }}
                  template(v-else-if="['CS','OE'].includes(match.bet_type)")
                    span {{ getName(match, 1) }} vs {{ getName(match, 2) }}
                  template(v-else)
                    span {{ getName(match, 1) }}
                template(v-else)
                  span {{ getName(match, 1) }}
                span.small.ml-1(v-if="racingList.includes(match.sports_type) && match.match_time")  (No. {{ $dayjs(match.match_time).format("MMDDhhmm") }})
              template(v-else)
                template(v-if="match.bet_type != 'OR'")
                  span.d-block {{ getName(match, 0) }}
                  span.score(v-if="runningScore(match) != ''") {{ runningScore(match) }}
                  template(v-if="!isStatement")
                    span.d-block(:class="match.home_giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 1) }}
                    span.d-block(:class="match.home_giving == 0 && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 2) }}
                  template(v-else)
                    span.d-block(:class="match.team_g == match.home_team_id && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 1) }}
                    span.d-block(:class="match.team_g == match.away_team_id && isBallDisplay ? 'team2' : 'team1'") {{ getName(match, 2) }}
                template(v-else)
                  .score(v-if="match.home_score != null") {{ match.home_score }}
                  span.team1 {{ getName(match, 1) }}
          .selector-odd.d-flex.justify-content-between
            template(v-if="racingList.includes(match.sports_type)")
              template(v-if="racingList1.includes(match.sports_type)")
                span.bet-type-text(v-if="['OU','OE'].includes(match.bet_type)") {{ $t("m.GH_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
                span.bet-type-text(v-else) {{ $t("m.GH_" + match.bet_type + (match.ball_home_3way == undefined ? '' : match.ball_home_3way)) }}
              template(v-if="racingList2.includes(match.sports_type)")
                span.bet-type-text(v-if="['OU','OE'].includes(match.bet_type)") {{ $t("m.GC_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
                span.bet-type-text(v-else-if="['CS'].includes(match.bet_type)") {{ match.criteria1 }}
                span.bet-type-text(v-else) {{ $t("m.GC_" + match.bet_type + (match.ball_home_3way == undefined ? '' : match.ball_home_3way)) }}
              template(v-if="racingList3.includes(match.sports_type)")
                span.bet-type-text(v-if="['OU','OE'].includes(match.bet_type)") {{ $t("m.GX_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
                span.bet-type-text(v-else) {{ $t("m.GX_" + match.bet_type + (match.ball_home_3way == undefined ? '' : match.ball_home_3way)) }}
              template(v-if="racingList4.includes(match.sports_type)")
                span.bet-type-text(v-if="['OU','OE','ML','1X2'].includes(match.bet_type)") {{ $t("m.GR_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
                span.bet-type-text(v-else-if="['CS'].includes(match.bet_type)") {{ match.criteria1 }}
                span.bet-type-text(v-else) {{ $t("m.GR_" + match.bet_type + (match.ball_home_3way == undefined ? '' : match.ball_home_3way)) }}
              template(v-if="racingList5.includes(match.sports_type)")
                span.bet-type-text(v-if="['OU','OE'].includes(match.bet_type)") {{ $t("m.MA_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
                template(v-else-if="['ML'].includes(match.bet_type)")
                  template(v-if="match.home_team_name == match.away_team_name")
                    span.bet-type-text(v-if="match.home_away==1")   {{ $t("m.MA_ANY_W_R")   }}
                    span.bet-type-text(v-else)   {{ $t("m.MA_NO_W_R")   }}
                  span.bet-type-text(v-else)  {{ $t("m.MA_" + match.bet_type + (match.home_away == undefined ? '' : match.home_away)) }}
                template(v-else-if="['CS'].includes(match.bet_type)")
                  span.bet-type-text(v-if="match.criteria2")  {{ match.criteria2 }} 
                  template(v-else-if="match.home_team_name == match.away_team_name")
                    span.bet-type-text(v-if="['3-0'].includes(match.criteria1)")  {{ $t("m.MA_PF") }}
                    span.bet-type-text(v-else) {{ $t("m.MA_W_" + match.criteria1.split('-')[0]) }}
                  span.bet-type-text(v-else) {{ match.criteria1 }}
                span.bet-type-text(v-else) {{ $t("m.MA_" + match.bet_type) }}
              .bet-type-odds
                .odds
                  span(:class="getNumberClass(match.odds_display)") {{ match.odds_display }}
            template(v-else)
              template(v-if="!isStatement")
                span.text
                  span.market-type {{ match.bet_type }}
                  span.team-name(:class="teamNameClass(match)") {{ betDisplay(match) }}
                    template(v-if="match.is_tm") &nbsp;{{ displayTimeRange(match.tm_time) }}
              template(v-else)
                span.text
                  span.market-type {{ match.bet_type }}
                  span.team-name(:class="teamNameClass(match)") {{ betDisplay(match) }}
                    template(v-if="isTM(match) && !!match.criteria1") &nbsp;{{ displayTimeRange(match.criteria1) }}
              .bet-type-odds
                template(v-if="match.criteria2")
                  template(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(match.bet_type)")
                    span.bet-type-text
                      span(:class="{ 'negetive' : showOdds(match.bet_type.toUpperCase(), match.home_away, match.home_giving, match.ball_display) < 0 }") {{ showOdds(match.bet_type.toUpperCase(), match.home_away, match.home_giving, match.ball_display) }}
                      template(v-if="match.criteria2 < 0")
                        span.negetive ({{ $numeral(match.criteria2).format("0") }})
                      template(v-else)
                        span ({{ $numeral(match.criteria2).format("0") }})
                  .odds
                    span(:class="{ 'negetive' : match.odds_display < 0 }") {{ match.odds_display }}
                template(v-else)
                  span.bet-type-text(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(match.bet_type)") {{ ballDisplay(match) }}
                  .odds
                    span(:class="getNumberClass(match.odds_display)") {{ match.odds_display }}
        .stake-info(v-else)
          template(v-if="['esports2'].includes(filterMenu)")
            .betslip-match
              .team-involved(v-if="match.game_type_name")
                span.market-type {{ match.game_type_name }} 
                span(v-if="match.game_market_name") ({{ match.game_market_name }})
            .selector-odd
              .bet-type-odds
                span.text-danger.text-uppercase.bet-type-text {{ match.bet_selection }}
                span.bet-type-text {{ match.bet_type_name }}
                span.bet-type-text @ {{ match.member_odds }}
          .betslip-match.others
            .game-name
              | {{ match.game_name }}

        .payout-wrapper
          .left
            | {{ $t("ui.stake") }}: 
            span.amount(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") {{ $numeral(match.bet_member).format("0,0.[00]") }}
            span.amount(v-else-if="['esports2'].includes(filterMenu)") {{ $numeral(match.bet_amount).format("0,0.[00]") }}
            span.amount(v-else) {{ $numeral(match.turnover).format("0,0.[00]") }}
          .right(v-if="!['Running', 'Waiting', 'Rejected'].includes(status)")
            template(v-if="match.winlose")
              template(v-if="match.payout || match.payout == 0")
                | {{ parseFloat(match.winlose) < 0 ? $t("ui.lose") : parseFloat(match.winlose) == 0 ? $t("ui.draw") : $t("ui.win") }}:
              template(v-else)
                | {{ $t("ui.payout") }}: 
              span.amount(:class="match.winlose != 0 ? match.winlose > 0 ? 'win-amount' : 'lose-amount' : ''")  {{ $numeral(match.winlose).format("0,0.00") }}
              template(v-if="match.cash_out")
                .small-text(data-bs-toggle='modal' :data-bs-target="'#modalCashout-info-' + uniqueID")
                  | ({{ $t("ui.cashout") }}: {{ $numeral(match.payout).format("0,0.00") }}) 
                  i.fas.fa-info-circle
      
        .cashout-wrapper(v-if="isCashoutButtonVisible")
          template(v-if="!cashout.confirm")
            .cashout-btn(@click="cashoutRequest")
              svg#Layer_1.icon-color(enable-background='new 0 0 24 24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg')
                path(d='m10.5 6 .5-.6v3.6c0 .6.4 1 1 1s1-.4 1-1v-3.6l.5.6c.4.4 1 .4 1.4 0s.4-1 0-1.4l-2.2-2.2c-.4-.4-1-.4-1.4 0l-2.3 2.2c-.3.4-.3 1 0 1.4.4.4 1.1.4 1.5 0zm9.5 2h-5.5v1c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-1h-5.5c-1.7 0-3 1.3-3 3v8c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-8c0-1.6-1.3-3-3-3zm-14 8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm6 1c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z')
              | {{ $t("ui.cashout") }} {{ $numeral(cashout.amount).format("0,0.00") }}
          template(v-else)
            .cashout-info
              .d-flex.justify-content-between.mb-2
                .left
                  | {{ $t("ui.stake") }}: 
                  span {{ $numeral(match.bet_member).format("0,0.00") }}
                .right
                  | {{ $t("ui.cashout") }}: 
                  span.payout-amount {{ $numeral(cashout.amount).format("0,0.00") }}
              .cashout-btn-wrapper
                .btn-cancel.flex-grow-1(@click="cashoutCancel" type="button") {{ $t('ui.cancel') }}
                .btn-confirm.flex-grow-1(@click="cashoutSubmit" type="button") 
                  span(v-if="!cashout.loading") {{ $t('ui.yes') }}
                  .spinner-grow.spinner-grow-sm.text-white(v-else)
        .cashout-wrapper(v-if="cashout.error != null")
          .cashout-info.text-center.text-info {{ $t("error.cashOutUnavailable") }}

        .collapse(:id="'statement-child-' + uniqueID" :data-bsparent="'#statement-' + index")
          .bet-details-important(v-if="['sportsbook','adjustment','void'].includes(filterMenu)")
            .bet-details-league {{ getName(match, 0) }}
            template(v-if="!this.vg1.includes(match.sports_type)")
              .bet-details-result(v-if="match.home_score != null")
                template(v-if="['CSHTFT', 'ETGHTFT'].includes(match.bet_type)")
                  span.mr-2(v-if="match.special") HT: {{ match.special.home_score_ht + "-" + match.special.away_score_ht }}
                  span FT: {{ match.home_score + "-" + match.away_score }}
                template(v-else)
                  | {{ $t("ui.result") }}: {{ match.home_score + "-" + match.away_score }}
          .bet-details-important(v-else)
            template(v-if="['esports2'].includes(filterMenu)")
              .bet-details-league(v-if="match.event_name") {{ match.event_name }}
              .bet-details-result(v-if="match.competition_name") {{ match.competition_name }}
              .bet-details-result {{ $t("ui.result") }}:
                span.text-uppercase.ml-1 {{ match.result }}
            template(v-if="['tournament','tournament_refund'].includes(filterMenu)")
              .bet-details-league(v-if="match.remark") {{ $t('m.' + match.remark) }}
              .bet-details-result {{ $t('m.ROOM_T' + match.room_type) }} 
              .bet-details-result {{ $t('ui.room_id') }}: {{ match.room_id }}
            template(v-else)
              .bet-details-league {{ match.game_name }}
              .bet-details-result(v-if="!['DBP', 'NEXT'].includes(match.game_provider)") {{ $t("ui.result") }}:
                span.result-icon.ml-1
                  template(v-if="isProviderSupported")
                    a.icon-info(
                      v-if="!loading[currentProviderConfig.loadingKey]" 
                      href="javascript:void(0);" 
                      title='Result' 
                      @click="handleResultClick" 
                      target="_blank"
                    )
                      i.fas.fa-chart-bar
                    span(v-else).fa.fa-spin.fa-spinner
                  template(v-else)
                    a.icon-info(
                      :href="resultUrl(match)" 
                      title='Result' 
                      target="result" 
                      @click="openResultWindow"
                    )
                      i.fas.fa-chart-bar
          .bet-details
            template(v-if="['tournament','tournament_refund'].includes(filterMenu)")
              .bet-details-row
                .left {{ $t("ui.points") }}: {{ $numeral(match.bet_payout).format("0,0.00") }}
                .right(v-if="match.jackpot_payout") {{ $t("ui.jackpot") }}: {{ $numeral(match.jackpot_payout).format("0,0.00") }} ({{ $t("ui.prize") }} x {{ $numeral(match.jackpot_value).format("0,0") }})
              .bet-details-row
                .left {{ $t("ui.ref_no") }}: {{ match.result_id }}
                .right {{ $t("ui.bet") }}: {{ $dayjs(match.bet_time).format("MM/DD/YYYY hh:mm:ss A") }}
            template(v-else)
              .bet-details-row
                .left {{ $t("ui.bet") }}: {{ match.created_on ? $dayjs(match.created_on).format("MM/DD/YYYY hh:mm:ss A") : $dayjs(match.bet_time).format("MM/DD/YYYY hh:mm:ss A")}}
                .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") {{ $t("ui.event") }}: {{ $dayjs(match.match_time).format("MM/DD/YYYY hh:mm A") }}
              .bet-details-row(v-if="['sportsbook','adjustment', 'void', 'livecasino', 'esports2'].includes(filterMenu)")
                template(v-if="['esports2'].includes(filterMenu)")
                  .left {{ $t("ui.comm") }}: {{ $numeral(match.comm).format("0,0.00") }}
                  .right.text-uppercase(v-if="match.member_odds_style") {{ $t("ui.odds") }}: {{ match.member_odds_style }}
                template(v-else)
                  .left {{ $t("ui.comm") }}: {{ $numeral(match.member_commission).format("0,0.00") }}
                  template(v-if="match['criteria2'] || match['bet_type_share'] == 'PARLAYMMO'")
                    .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") {{ $t("ui.odds") }}: {{ $t(odds[5]) }}
                  template(v-else)
                    .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") {{ $t("ui.odds") }}: {{ $tc(odds[match.odds_type]) }}
              .bet-details-row
                .left ID: {{ ['sportsbook','adjustment','void'].includes(filterMenu) ? uniqueID : match.bet_id }}
                .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") IP: {{ match.ip }}
        .btn-more-detail(:id="'statement-child-btn-' + uniqueID" data-bs-toggle='collapse' :data-bs-target="'#statement-child-' + uniqueID" :aria-expanded="detailsExpanded" :aria-controls="'statement-child-' + uniqueID") {{ detailButtonText }}
  template(v-else)
    .stake-info-wrapper
      .stake-info
        .betslip-match.others
          .settlement-amount.mr-1 {{ $t("ui.settled_amount") }}:
          span(:class="{ 'text-danger1': parseFloat(match.settled_amount) < 0 }") {{ $numeral(match.settled_amount).format("0,0.00") }}

  .modal.fade.modal-cashout(
    :id="'modalCashout-info-' + uniqueID"
    tabindex='-1'
    role='dialog'
    aria-labelledby='modalCashout'
    aria-hidden='true'
  )
    .modal-dialog.modal-dialog-centered(role='document')
      .modal-content
        .header {{ $t("ui.cashout") + " " + $t("ui.details") }} 
        .modal-body.text-center
          .info-row.d-flex.justify-content-between
            .text-left
              strong {{ $t("ui.date") }}
            .text-right {{ $dayjs(match.result_time).format("MM/DD/YYYY hh:mm:ss A") }}
          .info-row.d-flex.justify-content-between
            .text-left
              strong {{ $t("ui.ref_no") }}
            .text-right {{ match.result_id }}
          .info-row.d-flex.justify-content-between
            .text-left
              strong {{ $t("ui.cashout_amount") }}
            .text-right {{ $numeral(match.payout).format("0,0.00") }}
          .d-flex
            .btn-close(data-bs-dismiss='modal' aria-label='Close') {{ $t("ui.close") }}
</template>

<script>
import config from "@/config";
import naming from "@/library/_name";
import cashout from "@/library/_xhr-cashout.js";
import calc from "@/library/_calculation.js";
import betSlipDetailToggle from "@/mixins/betSlipDetailToggle";

export default {
  mixins: [betSlipDetailToggle],
  props: {
    index: {
      type: Number
    },
    match: {
      type: [Object, Array]
    },
    filterMenu: {
      type: String,
      default: "sportsbook"
    },
    leagueList: {
      type: [Object, Array]
    },
    matchList: {
      type: [Object, Array]
    },
    status: {
      type: String,
      default: ""
    },
    isStatement: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: {
        arcadia: false,
        pgsoft: false,
        pragmatic: false,
        joker: false,
        spp: false,
        jili: false,
        lcppg: false,
        uusl: false,
        next: false,
        dbhash: false,
        wow: false,
        ai: false,
        wf: false,
        live22: false,
        epw: false,
        awc: false,
        aio: false,
        onlive: false,
        mt: false,
        foxy: false
      },
      cashout: {
        timer: null,
        loading: false,
        interval: 15000,
        data: null,
        error: null,
        available: false,
        amount: 0,
        confirm: false
      },
      balance: 0,
      blinking: false,
      animation: null
    };
  },
  computed: {
    isLiveMarket() {
      const item = this.match;
      if (!item) return false;
      if (item.market_type == 3) return true;
      const live = this.$store.state.cache.live;
      return item.match_id != null && live != null && live[item.match_id] == 3;
    },
    vg1() {
      return config.vg1;
    },
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    racingList2() {
      return config.racingList2;
    },
    racingList3() {
      return config.racingList3;
    },
    racingList4() {
      return config.racingList4;
    },
    racingList5() {
      return config.racingList5;
    },
    racingList6() {
      return config.racingList6;
    },
    racingList7() {
      return config.racingList7;
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    odds() {
      return config.oddsTypeLocale;
    },
    language() {
      return this.$store.getters.language;
    },
    uniqueID() {
      if (this.match) {
        return this.match.result_id || this.match.bet_id;
      }
    },
    isBallDisplay() {
      var result = naming.ballDisplay2(this.match.ball_display, this.match.home_giving, this.match.home_away, this.match.bet_type, this);
      if (["HDP", "HDPH"].includes(this.match.bet_type)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    currency_code() {
      return this.$store.getters.currencyCode;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    decimalOdds() {
      return calc.convertDecimal(this.match.odds_type, this.match.odds_display);
    },
    isCashoutAvailable() {
      if (!this.isLoggedIn) return false;
      if (!this.match.cashout) return false;
      if (this.match.mmo == true) return false;
      if (!["HDP", "HDPH", "OU", "OUH"].includes(this.match.bet_type)) return false;
      if (this.match.bet_status.toUpperCase() != "ACCEPTED") return false;
      return true;
    },
    isCashoutButtonVisible() {
      if (!this.isCashoutAvailable) return false;
      if (!this.cashout.available) return false;
      if (this.cashout.amount <= 0) return false;
      return true;
    },
    formattedCashoutDate() {
      const resultTime = this.match.result_time || "N/A";
      return resultTime !== "N/A" ? this.$dayjs(resultTime).format("MM/DD/YYYY hh:mm:ss A") : "N/A";
    },
    cashoutResultId() {
      return this.match.result_id || this.match.bet_id;
    },
    formattedCashoutAmount() {
      return this.$numeral(this.match.payout).format("0,0.00");
    },
    gameProviderConfig() {
      return {
        AR: { method: "getResultAR", loadingKey: "arcadia", param: "bet_id" },
        PGS: { method: "getResultPGS", loadingKey: "pgsoft", param: "bet_id" },
        PP: { method: "getResultPPG", loadingKey: "pragmatic", param: "match" },
        JK: { method: "getResultJKR", loadingKey: "joker", param: "match" },
        SP: { method: "getResultSPP", loadingKey: "spp", param: "match" },
        JILI: { method: "getResultJILI", loadingKey: "jili", param: "match" },
        "PP-C": { method: "getResultLCPPG", loadingKey: "lcppg", param: "match" },
        UU: { method: "getResultUUSL", loadingKey: "uusl", param: "match" },
        NEXT: { method: "getResultNEXT", loadingKey: "next", param: "match" },
        DB: { method: "getResultDbHash", loadingKey: "dbhash", param: "match" },
        WOW: { method: "getResultWOW", loadingKey: "wow", param: "match" },
        AI: { method: "getResultAI", loadingKey: "ai", param: "match" },
        WF: { method: "getResultWF", loadingKey: "wf", param: "match" },
        OSG: { method: "getResultLive22Gaming", loadingKey: "live22", param: "match" },
        EPW: { method: "getResultEPW", loadingKey: "epw", param: "match" },
        SEXYBCRT: { method: "getResultAWC", loadingKey: "awc", param: "match" },
        BI: { method: "getResultAIO", loadingKey: "aio", param: "match" },
        ONLIVE: { method: "getResultOnlive", loadingKey: "onlive", param: "match" },
        MTLIVE: { method: "getResultMtCasino", loadingKey: "mtlive", param: "match" },
        FOXY: { method: "getResultFoxy", loadingKey: "foxy", param: "match" }
      };
    },
    supportedGameProviders() {
      return ["AR", "PGS", "PP", "JK", "SP", "JILI", "PP-C", "UU", "NEXT", "DB", "WOW", "AI", "WF", "OSG", "EPW", "SEXYBCRT", "BI", "ONLIVE", "MTLIVE", "FOXY"];
    },
    currentProviderConfig() {
      return this.gameProviderConfig[this.match.game_provider];
    },
    isProviderSupported() {
      return this.supportedGameProviders.includes(this.match.game_provider);
    }
  },
  watch: {
    match(newVal, oldVal) {
      this.cashoutCheck();
    }
  },
  mounted() {
    this.cashout.available = this.match.cashout || false;
    this.cashoutCheck();
  },
  beforeDestroy() {
    if (this.animation) {
      clearTimeout(this.animation);
      this.animation = null;
    }
    if (this.cashout.timer) {
      clearTimeout(this.cashout.timer);
      this.cashout.timer = null;
    }
  },
  methods: {
    cashoutRequest() {
      this.cashout.confirm = true;
    },
    cashoutCancel() {
      this.cashout.confirm = false;
    },
    showCashoutModal() {
      $("#modalCashout-info-" + this.uniqueID).modal("show");
    },
    showOdds(bet_type, home_away, giving, odds) {
      return naming.ballDisplayMMO1(odds, giving, home_away, bet_type, this);
    },
    handleResultClick() {
      const provider = this.match.game_provider;

      // Fallback to direct method calls if config approach fails
      switch (provider) {
        case "AR":
          if (!this.loading.arcadia) this.getResultAR(this.match.bet_id);
          break;
        case "PGS":
          if (!this.loading.pgsoft) this.getResultPGS(this.match.bet_id);
          break;
        case "PP":
          if (!this.loading.pragmatic) this.getResultPPG(this.match);
          break;
        case "JK":
          if (!this.loading.joker) this.getResultJKR(this.match);
          break;
        case "SP":
          if (!this.loading.spp) this.getResultSPP(this.match);
          break;
        case "JILI":
          if (!this.loading.jili) this.getResultJILI(this.match);
          break;
        case "PP-C":
          if (!this.loading.lcppg) this.getResultLCPPG(this.match);
          break;
        case "UU":
          if (!this.loading.uusl) this.getResultUUSL(this.match);
          break;
        case "NEXT":
          if (!this.loading.next) this.getResultNEXT(this.match);
          break;
        case "DB":
          if (!this.loading.dbhash) this.getResultDbHash(this.match);
          break;
        case "WOW":
          if (!this.loading.wow) this.getResultWOW(this.match);
          break;
        case "AI":
          if (!this.loading.ai) this.getResultAI(this.match);
          break;
        case "WF":
          if (!this.loading.wf) this.getResultWF(this.match);
          break;
        case "OSG":
          if (!this.loading.live22) this.getResultLive22Gaming(this.match);
          break;
        case "EPW":
          if (!this.loading.epw) this.getResultEPW(this.match);
          break;
        case "SEXYBCRT":
          if (!this.loading.awc) this.getResultAWC(this.match);
          break;
        case "BI":
          if (!this.loading.aio) this.getResultAIO(this.match);
          break;
        case "ONLIVE":
          if (!this.loading.onlive) this.getResultOnlive(this.match);
          break;
        case "MTLIVE":
          if (!this.loading.mt) this.getResultMtCasino(this.match);
          break;
        case "FOXY":
          if (!this.loading.foxy) this.getResultFoxy(this.match);
          break;
        default:
          console.warn("Unsupported provider:", provider);
      }
    },
    handleFeedback(status) {
      this.cashout.confirm = false;
      this.cashout.loading = false;
      this.$helpers.handleFeedback(status, true);

      this.cashoutCheck();
      setTimeout(() => {
        this.$emit("runner");
      }, 1000);
    },
    cashoutSubmit() {
      if (this.isCashoutAvailable == false) return;
      if (this.cashout.available == false) return;
      const args = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        betID: this.match.bet_id.toString(),
        moMatchID: this.match.match_id.toString(),
        betType: this.match.bet_type.toString(),
        placementRunningScore: `${this.match.home_running_score}-${this.match.away_running_score}`,
        homeGiving: this.match.home_giving.toString(),
        itemOdds: this.match.odds_display,
        itemType: this.match.odds_type,
        placementBall: Math.abs(parseFloat(this.match.ball)).toString(),
        placementTeam: this.match.home_away.toString(),
        betStatus: this.match.cashout_status,
        betMember: this.match.bet_member.toString(),
        cashOutTime: new Date().toISOString(),
        ot: this.match.ot,
        cashout_amt: this.cashout.amount.toString()
      };

      this.cashout.loading = true;
      this.balance = this.cashout.amount;
      cashout.betCashout(args).then(
        res => {
          this.cashout.confirm = false;
          this.cashout.loading = false;
          if (res.success) {
            if (res.data["pending_bet"]) {
              this.cashoutCheck();
              // setTimeout(() => {
              //   if (EventBus.betListPending) {
              //     EventBus.betListPending();
              //   }
              // }, 1000);
            } else {
              this.$swal(this.$t("ui.cashout"), this.$t("message.cashoutSuccesfully"), "info").then(result => {
                // Emit event to trigger tab refresh to "Running" tab
                this.cashoutCheck();
                setTimeout(() => {
                  // if (EventBus.betListAccept) {
                  //   EventBus.betListAccept();
                  // }
                  setTimeout(() => {
                    if (EventBus.getBalance) {
                      EventBus.getBalance();
                    }
                  }, 500);
                }, 500);
                this.$emit("cashoutSuccess");
              });
            }
          } else {
            this.handleFeedback(res.status);
          }
        },
        err => {
          this.handleFeedback(err.status);
        }
      );
    },
    cashoutCheck() {
      if (this.isCashoutAvailable == false) return;
      if (this.match.goal == 1) {
        this.cashout.loading = false;
        this.cashout.available = false;
        this.cashout.amount = 0;
        this.cashout.error = "matchGoal";
        return;
      }

      this.cashout.confirm = false;
      const args = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        betID: this.match.bet_id.toString(),
        moMatchID: this.match.match_id.toString(),
        betType: this.match.bet_type.toString(),
        placementRunningScore: `${this.match.home_running_score}-${this.match.away_running_score}`,
        homeGiving: this.match.home_giving.toString(),
        itemOdds: this.match.odds_display,
        itemType: this.match.odds_type,
        placementBall: Math.abs(parseFloat(this.match.ball)).toString(),
        placementTeam: this.match.home_away.toString(),
        betStatus: this.match.cashout_status,
        betMember: this.match.bet_member.toString(),
        cashOutTime: new Date().toISOString(),
        ot: this.match.ot
      };

      this.cashout.loading = true;
      this.balance = this.cashout.amount;
      cashout.betCashoutCheck(args).then(
        res => {
          this.cashout.loading = false;
          if (res.success) {
            this.cashout.data = res.data;
            this.cashout.amount = parseFloat(res.data.balance) || 0;
            this.cashout.available = this.cashout.amount > 0 || false;
            this.cashout.error = null;
          } else {
            this.cashout.amount = 0;
            this.cashout.available = false;
            this.cashout.error = res.status;
          }
          if (this.balance != 0) {
            if (this.balance != this.cashout.amount) {
              this.blinking = true;
              this.animation = setTimeout(() => {
                this.blinking = false;
                if (this.animation) clearTimeout(this.animation);
                this.animation = null;
              }, 10000);
            }
          }
        },
        err => {
          this.cashout.loading = false;
          this.cashout.available = false;
          this.cashout.amount = 0;
          this.cashout.error = err.status;
        }
      );
    },
    openResultWindow(event) {
      event.preventDefault();
      const url = this.resultUrl(this.match);
      window.open(url, "result", "top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no");
    },
    getName: function(match, mode) {
      let name = "";
      if (mode == 0) {
        if (["running", "waiting", "rejected"].includes(this.status)) {
          name = match["name_" + this.language] ? match["name_" + this.language] : match["league_name"];
        } else {
          this.leagueList.forEach(x => {
            if (x.league_id == match.league_id) {
              name = x["name_" + this.language] ? x["name_" + this.language] : x["name_en"];
            }
          });
        }
      } else {
        if (["running", "waiting", "rejected"].includes(this.status)) {
          if (mode == 1) {
            name = match["home_name_" + this.language] ? match["home_name_" + this.language] : match["home_team_name"];
          } else {
            name = match["away_name_" + this.language] ? match["away_name_" + this.language] : match["away_team_name"];
          }
        } else {
          this.matchList.forEach(y => {
            if (y.match_id == match.match_id) {
              if (mode == 1) {
                name = y["home_name_" + this.language] ? y["home_name_" + this.language] : y["home_name_en"];
              } else {
                name = y["away_name_" + this.language] ? y["away_name_" + this.language] : y["away_name_en"];
              }
            }
          });
        }
      }
      return name;
    },
    resultUrl(e) {
      let mode = this.filterMenu;
      switch (mode) {
        case "slots":
          var result = config.r2ResultUrl() + e.bet_id;
          if (e.bet_id.includes("LOSG_") || e.bet_id.includes("LCB_")) {
            result = config.r3ResultUrl() + e.bet_id;
          }
          return result;
        case "livecasino":
          var account_id = this.$store.getters.accountId;
          var session_token = this.$store.getters.sessionToken;
          var result = config.r1ResultUrl() + "result_id=" + e.result_id + "&login_id=" + account_id + "&auth_token=" + session_token;
          return encodeURI(result);
      }
    },
    getResultLive22Gaming(e) {
      if (this.loading.live22) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        currency: this.currency_code
      };
      this.loading.live22 = true;
      this.$http.post(config.live22Path, args).then(
        res => {
          this.loading.live22 = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultlive22", "top=10,height=400,width=640,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.live22 = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAR(e) {
      if (this.loading.arcadia) return;
      var id = e.replace("AR_", "");
      var url = "";
      const args = {
        cert: config.arcadeCert,
        transId: id.toString()
      };
      this.loading.arcadia = true;
      this.$http.post(config.arcadePath, args).then(
        res => {
          this.loading.arcadia = false;
          if (res.data) {
            url = res.data.url;
            if (url) {
              window.open(url, "resultar", "top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.arcadia = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultPGS(e) {
      if (this.loading.pgsoft) return;
      var id = e;
      var url = "";
      const args = {
        resultid: id.toString(),
        language: "en"
      };
      this.loading.pgsoft = true;
      this.$http.post(config.pgsPath, args).then(
        res => {
          this.loading.pgsoft = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultpgs", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.pgsoft = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultPPG(e) {
      if (this.loading.pragmatic) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id
      };
      this.loading.pragmatic = true;
      this.$http.post(config.ppgPath, args).then(
        res => {
          this.loading.pragmatic = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultpgs", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.pragmatic = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultJKR(e) {
      if (this.loading.joker) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id
      };
      this.loading.joker = true;
      this.$http.post(config.jkrPath, args).then(
        res => {
          this.loading.joker = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultjkr", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.joker = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultSPP(e) {
      if (this.loading.spp) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString()
        // userid: e.member_id
      };
      this.loading.spp = true;
      this.$http.post(config.sppPath, args).then(
        res => {
          this.loading.spp = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultspp", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.spp = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultJILI(e) {
      if (this.loading.jili) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        language: "en"
      };
      this.loading.jili = true;
      this.$http.post(config.jiliPath, args).then(
        res => {
          this.loading.jili = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultjili", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.jili = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultLCPPG(e) {
      if (this.loading.lcppg) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: "en"
      };
      this.loading.lcppg = true;
      this.$http.post(config.lcppgPath, args).then(
        res => {
          this.loading.lcppg = false;
          if (res.data) {
            url = res.data.history_url;
            if (url) {
              window.open(url, "resultlcppg", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.lcppg = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultUUSL(e) {
      if (this.loading.uusl) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString()
      };
      this.loading.uusl = true;
      this.$http.post(config.uuslPath, args).then(
        res => {
          this.loading.uusl = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultuusl", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.uusl = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultNEXT(e) {
      if (this.loading.next) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString()
      };
      this.loading.next = true;
      this.$http.post(config.nextPath, args).then(
        res => {
          this.loading.next = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.next = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultDbHash(e) {
      if (this.loading.dbhash) return;
      this.loading.dbhash = true;
      var url = config.dbhashPath + "?result_id=" + e.bet_id.toString() + "&auth_token=" + this.$store.getters.sessionToken + "&login_id=" + e.member_id;
      this.loading.dbhash = false;
      window.open(url, "resultdbhash", "top=10,height=600,width=320,status=no,toolbar=no,menubar=no,location=no");
    },
    getResultWOW(e) {
      if (this.loading.wow) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: this.language
      };
      this.loading.wow = true;
      this.$http.post(config.wowgamingPath, args).then(
        res => {
          this.loading.wow = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.wow = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAI(e) {
      if (this.loading.ai) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        language: this.language
      };
      this.loading.ai = true;
      this.$http.post(config.aicasinoPath, args).then(
        res => {
          this.loading.ai = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultnext", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.ai = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultWF(e) {
      if (this.loading.wf) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        currency: this.currency_code
      };
      this.loading.wf = true;
      this.$http.post(config.wfPath, args).then(
        res => {
          this.loading.wf = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultwf", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.wf = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultEPW(e) {
      if (this.loading.epw) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        currency: this.currency_code
      };
      this.loading.epw = true;
      this.$http.post(config.epwPath, args).then(
        res => {
          this.loading.epw = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultwf", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.epw = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAWC(e) {
      if (this.loading.awc) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id
      };
      this.loading.awc = true;
      this.$http.post(config.awcPath, args).then(
        res => {
          this.loading.awc = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultawc", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.awc = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultAIO(e) {
      if (this.loading.aio) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        currency: this.currency_code
      };
      this.loading.aio = true;
      this.$http.post(config.aioPath, args).then(
        res => {
          this.loading.aio = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              const newWindow = window.open("", "resultaio", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
              if (newWindow) {
                newWindow.document.head.innerHTML = `
                    <title>Game Result</title>
                    <link rel="stylesheet" href="/css/bootstrap.min.css">
                    <link rel="stylesheet" href="/css/app.css">
                    <link rel="stylesheet" href="/css/desktop/info.css">
                    <style>
                      body {
                        margin: 20px;
                        background: #F4F7FC;
                      }
                    </style>
                  `;
                newWindow.document.body.innerHTML = `<div class="result-container">${url}</div>`;
              }
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.aio = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultOnlive(e) {
      if (this.loading.onlive) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        currency: this.currency_code
      };
      this.loading.onlive = true;
      this.$http.post(config.onlivePath, args).then(
        res => {
          this.loading.onlive = false;
          if (res.data) {
            url = res.data.recordUrl;
            if (url) {
              window.open(url, "resultonlive", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.onlive = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultMtCasino(e) {
      if (this.loading.mt) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        currency: this.currency_code
      };
      this.loading.mt = true;
      this.$http.post(config.mtcasinoPath, args).then(
        res => {
          this.loading.mt = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultmtcasino", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.mt = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getResultFoxy(e) {
      if (this.loading.foxy) return;
      var id = e.bet_id;
      var url = "";
      const args = {
        resultid: id.toString(),
        userid: e.member_id,
        currency: this.currency_code
      };
      this.loading.foxy = true;
      this.$http.post(config.foxyPath, args).then(
        res => {
          this.loading.foxy = false;
          if (res.data) {
            url = res.data.detail_url;
            if (url) {
              window.open(url, "resultfoxy", "top=10,height=737,width=414,status=no,toolbar=no,menubar=no,location=no");
            } else {
              this.$swal("Error", res.data.errorMessage, "error");
            }
          } else {
            this.$swal("Error", res.data.errorMessage, "error");
          }
        },
        err => {
          this.loading.foxy = false;
          this.$swal("Error", err, "error");
        }
      );
    },
    getSportsImage(e) {
      if (e.sports_type == -1) {
        e.sports_type = 1;
      }
      return config.getSportsImage(e.sports_type);
    },
    betType(e) {
      return this.$t("m.BS_" + e.bet_type);
    },
    betDisplay(e) {
      return naming.betDisplay(e, this);
    },
    runningScore(e) {
      if (e.market_type == 3 && e.home_running_score != null) {
        return `[${e.home_running_score}-${e.away_running_score}]`;
      }
      return "";
    },
    teamNameClass(e) {
      if (!this.isBallDisplay) {
        return "";
      }
      if (!this.isStatement) {
        return (e.home_giving == 0 && e.home_away == 2) || (e.home_giving == 1 && e.home_away == 1) ? "team2" : "team1";
      }
      return (e.team_g == e.away_team_id && e.home_away == 2) || (e.team_g == e.home_team_id && e.home_away == 1) ? "team2" : "team1";
    },
    ballDisplay(e) {
      // if(e.ball_display) {
      if (!this.isStatement) {
        return naming.ballDisplay2(e.ball_display, e.home_giving, e.home_away, e.bet_type, this);
      } else {
        return naming.ballDisplay1(e, this);
      }
    },
    getNumberClass(e) {
      return parseFloat(e) >= 0 ? "" : "negetive";
    },
    displayTimeRange(tm_time) {
      if (tm_time == null || tm_time === "") {
        return "";
      }
      const startLabel = "00:00";
      const endLabel = String(tm_time).padStart(2, "0") + ":00";
      return "(" + [startLabel, endLabel].join(" - ") + ")";
    },
    isTM(e) {
      return e["criteria1"] && ["HDP", "HDPH", "OU", "OUH"].includes(e["bet_type"].toUpperCase()) && !e["cash_out"];
    }
  }
};
</script>
